import React, { useState } from "react";
import { api } from "@/lib/api";
import { Bell, CheckCheck } from "lucide-react";
import { usePoll } from "@/components/common";

const TONE = { deposit: "bg-blue-50", order: "bg-indigo-50", timer: "bg-amber-50", adjustment: "bg-rose-50", support: "bg-emerald-50", rate: "bg-blue-50", info: "bg-slate-50" };

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/customer/notifications").then((r) => setItems(r.data)).catch(() => {});
  usePoll(load, 6000, []);

  const markAll = async () => { await api.post("/customer/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/customer/notifications/${id}/read`); load(); };

  return (
    <div className="space-y-6 max-w-3xl">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Notifications</h1>
        <button onClick={markAll} data-testid="notifications-read-all" className="inline-flex items-center gap-1.5 text-sm text-blue-600 font-medium hover:underline">
          <CheckCheck className="w-4 h-4" /> Mark all read
        </button>
      </div>
      {items.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-400">No notifications.</div>
      ) : (
        <div className="space-y-2" data-testid="notifications-list">
          {items.map((n) => (
            <div key={n.id} onClick={() => !n.read && markOne(n.id)}
              className={`flex gap-3 p-4 rounded-2xl border cursor-pointer transition ${n.read ? "bg-white border-slate-200" : `${TONE[n.type] || "bg-slate-50"} border-blue-200`}`}>
              <div className="w-9 h-9 rounded-xl bg-white border border-slate-200 flex items-center justify-center shrink-0">
                <Bell className="w-4 h-4 text-blue-600" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-slate-900 text-sm">{n.title}</span>
                  {!n.read && <span className="w-2 h-2 rounded-full bg-blue-600" />}
                </div>
                <p className="text-sm text-slate-600 mt-0.5">{n.message}</p>
                <span className="text-xs text-slate-400 mt-1 block">{new Date(n.created_at).toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
